








import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import {videoPlayer} from 'vue-vjs-hls';
import {Content, DummySourceURL, EmptyContent} from '@/types/material/Content';

@Component({
  components: {
    VideoPlayer: videoPlayer,
  },
})
export default class ContentVideoPlayer extends Vue {
  // prop
  @Prop({default: EmptyContent})
  content!: Content;
  @Prop({default: false})
  fastForward!: boolean;

  // data
  options: any = {
    autoplay: false, // ページを開いたときの自動再生を制御
    start: 0, // 開始時間
    controlBar: {
      remainingTimeDisplay: false,
      playToggle: {},
      fullscreenToggle: {},
      volumeMenuButton: {
        inline: false,
        vertical: true,
      },
      timeDivider: true,
      durationDisplay: true,
      currentTimeDisplay: true,
    },
    source: {
      withCredentials: true,
      type: 'application/x-mpegURL',
      // デフォルト値が必要
      src: DummySourceURL,
    },
    language: 'ja',
    techOrder: this.isInternetExplorer ? ['flash'] : ['html5'],
  };
  timer: number = 0;
  currentTime: number = 0;

  // computed
  get player(): any {
    // @ts-ignore
    return this.$refs.hlsPlayer.player;
  }

  get isInternetExplorer(): boolean {
    const userAgent = window.navigator.userAgent.toLowerCase();
    /* tslint:disable:max-line-length */
    return (userAgent.indexOf('msie') > -1) && (userAgent.indexOf('opera') === -1) || (userAgent.indexOf('trident/7') > -1);
  }

  // watch
  @Watch('content')
  onChangeContent() {
    if (!this.fastForward) {
      this.player.controlBar.progressControl.hide(); // プログレスバーの制御
    }
    this.addRewindButton();
    this.options.start = this.content.latestTimeSeconds; // 開始時間
    this.options.source.src = this.content.sourceURL; // URL
    this.options.poster = this.content.thumbnailURL; // サムネイル
  }

  @Watch('timer')
  onChangeTimer() {
    this.save();
  }

  // method
  playerStateChanged(event: any): void {
    if (event.ended) {
      this.viewed(); // 動画再生完了
    }

    if (event.currentTime) {
      this.currentTime = event.currentTime; // 現在の動画再生時間
    }
    // console.log(event); // debug
  }

  addRewindButton() {
    const button = this.player.controlBar.addChild('button');
    const dom = button.el();
    button.addClass('vjs-rewind-control');
    button.addClass('buttonClass');
    button.setAttribute('title', 'Rewind');
    button.enable();
    dom.innerHTML = '<span class="vjs-control-text">Rewind</span>';
    dom.onclick = this.rewind;
    dom.onMousedown = this.rewind;
    dom.onTouchstart = this.rewind;
  }

  rewind(event: any) {
    this.setCurrentTime(-15);
    event.preventDefault();
  }

  setCurrentTime(time: number) {
    this.player.currentTime(this.player.currentTime() + time);
  }

  @Emit('viewed')
  viewed(): void {
    return;
  }

  @Emit('save')
  save(): number {
    return this.currentTime;
  }

  // lifecycle hooks
  created(): void {
    setInterval(() => {
      this.timer++;
    }, 10000);
  }
}
